import React from 'react';
import { getMessage } from '@tcc/i18n';

import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';

import { toDateString } from '../../../utils/date';
import { createUnit } from '../../../i18n/unitQtyWrapper';
import { LOCALE_GROUPS } from '../../../constants/units';

import styles from '../cardAndPreview/cardAndPreview.css';

export type FHAPreviewProps = {
  date: string,
  gdus?: number,
  hasHistoricWeather: boolean,
  microsoftGDDGlobalRelease: boolean,
  locale: string,
  lowPercent: number,
  onLeftClick: () => void,
  onRightClick: () => void,
  precipitation?: number,
};

export function FHAPreview({
  date,
  hasHistoricWeather,
  microsoftGDDGlobalRelease,
  onLeftClick,
  onRightClick,
  locale,
  lowPercent,
  gdus = 0,
  precipitation = 0,
}: FHAPreviewProps) {
  const time = toDateString(date, locale);
  const precipLocalized = createUnit(Number(precipitation), 'millimeter')
    .forLocaleGroup(LOCALE_GROUPS.RAINFALL)
    .toString({ precision: 1 });
  const lowPercentLocalized = createUnit(lowPercent, 'percent').toString();

  return (
    <PreviewNavigationCard
      onLeftClick={onLeftClick}
      onRightClick={onRightClick}
      testId="dmb-fha"
    >
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="fha-preview-card-current-date"
        >
          {time}
        </div>
        <h3 data-test-id="fha-preview-event-data">
          {hasHistoricWeather ? (
            <>
              <span data-test-id="fha-preview-event-data-precipitation">{`${getMessage(
                'card.fha.seasonToDate'
              )}: ${precipLocalized} `}</span>
              <span data-test-id="fha-preview-event-data-low-percent">{` ${getMessage(
                'card.fha.low'
              )}: ${lowPercentLocalized} `}</span>
            </>
          ) : null}

          {microsoftGDDGlobalRelease || hasHistoricWeather ? (
            <span data-test-id="fha-preview-event-data-gdus">{` ${getMessage('card.fha.gdus')}: ${gdus}`}</span>
          ) : null}
        </h3>
      </div>
    </PreviewNavigationCard>
  );
}
